import { SelectOptionType } from '@octano/global-ui';
import { useCallback } from 'react';
import { getEditResponsiblesActionRequest } from '../api';

export const useContinuousEducationSearchResponsible = () => {
  return useCallback(async (searchText: string): Promise<
    SelectOptionType[]
  > => {
    const { data } = await getEditResponsiblesActionRequest(searchText);
    if (data) {
      return data.map((responsible) => ({
        value: responsible.id,
        label: responsible.fullName ?? '',
      }));
    }
    return [];
  }, []);
};
